import { useMemo, useRef, useState } from 'react';
import { detectEmphasisFormattingInSelection } from '../../util/notes';
export function useInitializeTextEmphasisButtonsContext() {
    const [isBoldActiveYn, setIsBoldActiveYn] = useState(false);
    const [isItalicActiveYn, setIsItalicActiveYn] = useState(false);
    const toggleBoldEmphasisButton = useRef(() => {
        setIsBoldActiveYn(prev => !prev);
    });
    const toggleItalicEmphasisButton = useRef(() => {
        setIsItalicActiveYn(prev => !prev);
    });
    const selectionForTextEmphasis = useRef((ctx, selection) => {
        const { isBoldActive, isItalicActive } = detectEmphasisFormattingInSelection(ctx, selection);
        setIsBoldActiveYn(isBoldActive);
        setIsItalicActiveYn(isItalicActive);
    });
    return useMemo(() => ({
        isBoldActiveYn,
        isItalicActiveYn,
        toggleBoldEmphasisButton: toggleBoldEmphasisButton.current,
        toggleItalicEmphasisButton: toggleItalicEmphasisButton.current,
        selectionForTextEmphasis: selectionForTextEmphasis.current,
    }), [
        isBoldActiveYn,
        isItalicActiveYn,
        toggleBoldEmphasisButton,
        toggleItalicEmphasisButton,
        selectionForTextEmphasis,
    ]);
}
//# sourceMappingURL=use_initialize_text_emphasis_buttons_context.js.map